export default () => ({
  isOpen: false,
  shouldBreak: false,

  initMediaQuery() {
    this.checkBreakpoint();
  },

  checkBreakpoint() {
    this.shouldBreak = window.innerWidth >= 1024;
    if (this.shouldBreak) this.isOpen = false;
  }
})